export const howCreateProductCard = [
	{
		icon: '👩‍💻',
		title: 'howCreateData_title1',
		subtitle: 'howCreateData_subtitle1',
	},
	{
		icon: '👗',
		title: 'howCreateData_title2',
		subtitle: 'howCreateData_subtitle2',
	},
	{
		icon: '🖼',
		title: 'howCreateData_title3',
		subtitle: 'howCreateData_subtitle3',
	},
	{
		icon: '🤘',
		title: 'howCreateData_title4',
		subtitle: 'howCreateData_subtitle4',
	},
];
